import graphql from "babel-plugin-relay/macro";

export const HomeContentQuery = graphql`
  query HomeContentQuery {
    pendingDocuments(showAll: false) {
      documents(first: 5) {
        totalCount
        edges {
          node {
            id
            pk
            name
            bloc {
              name
            }
            isHomeBloc
            category {
              name
            }
            effectiveDate
            restricted
            legacyEffectiveDate
          }
        }
      }
      viewOnlyPks
    }
    documentsToReview(justMine: false) {
      documents(first: 5) {
        totalCount
        edges {
          node {
            id
            pk
            name
            bloc {
              name
            }
            isHomeBloc
            category {
              name
            }
            expirationDate
            restricted
          }
        }
      }
      buckets
    }
    myDocumentsToAcknowledge(first: 5) {
      totalCount
      edges {
        node {
          totalAcknowledged
          totalAssigned
          line {
            pk
            document {
              pk
              name
              hasAttachments
              effectiveDate
              legacyEffectiveDate
              restricted
              category {
                name
              }
              bloc {
                name
              }
              isHomeBloc
            }
          }
        }
      }
    }
    recentlyRevisedDocuments {
      documents(first: 5) {
        totalCount
        edges {
          node {
            pk
            name
            bloc {
              name
            }
            category {
              name
            }
            bloc {
              name
            }
            isHomeBloc
            revisedFromParent
            effectiveDate
            legacyEffectiveDate
            restricted
            revisedFromParentStatus
          }
        }
      }
      buckets
    }
    blocSystemDocumentTemplatesAcceptance {
      blocSystemDocumentTemplates(first: 5) {
        totalCount
        edges {
          node {
            systemDocumentTemplate {
              pk
              name
              category {
                name
              }
            }
            publishDate
            document {
              pk
            }
          }
        }
      }
      buckets
    }
    currentTenant {
      settings {
        customWelcomeContentShow
        customWelcomeContentPsa
      }
    }
  }
`;
